import { FeedbackTypeEnum } from 'api';

export const formatAiFeedbackType = (feedbackType: FeedbackTypeEnum) => {
  switch (feedbackType) {
    case FeedbackTypeEnum.INCORRECT_DETECTION:
      return 'Incorrect object detected';
    case FeedbackTypeEnum.MISSING_DETECTION:
      return 'Missing object detected';
    case FeedbackTypeEnum.OTHER:
      return 'Other';
    default:
      return '';
  }
};
